import React from 'react';
import { Link } from 'react-router-dom';
import { SettingOutlined, BarChartOutlined, ToolOutlined, EnvironmentOutlined } from '@ant-design/icons';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const menuItems = [
    {
      key: '1',
      icon: <EnvironmentOutlined />,
      label: 'Map View',
      to: '/',
    },
    {
      key: '2',
      icon: <SettingOutlined />,
      label: 'Devices',
      to: '/device',
    },
    {
      key: '3',
      icon: <BarChartOutlined />,
      label: 'Data Pane',
      to: '/data',
    },
    {
      key: '4',
      icon: <ToolOutlined />,
      label: 'Configuration',
      to: '/Config',
    },
  ];

  return (
    <aside
    className={`fixed top-0 left-0 z-1000 h-full bg-white shadow-md transition-all duration-200 ${
      isOpen ? 'w-[200px]' : 'w-[80px]'
    }`}
    style={{
      marginTop: '64px', // Adjust this if your header height changes
    }}
  >
    <div className="p-4">
      <div className="space-y-4">
        {menuItems.map((item) => (
          <Link
            key={item.key}
            to={item.to}
            className="flex items-center justify-start p-2 hover:bg-gray-200 rounded-md"
          >
            <span className="flex items-center justify-center text-xl flex-shrink-0">{item.icon}</span>
            {isOpen && (
              <span className="ml-4 text-base text-gray-700 font-medium">
                {item.label}
              </span>
            )}
          </Link>
        ))}
      </div>
    </div>
  </aside>
  );
};

export default Sidebar;